import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService as Auth0SDK } from "@auth0/auth0-angular";
import { Observable } from "rxjs";
import { filter, map, switchMap, take } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { BASE_API_URL } from "../core/environment.tokens";

// TODO: Put in a service before using somewhere else.
// TODO: This doesn't work? Testing for now...
if (environment.production) {
    (window as any).newrelic = (window as any).newrelic || {};
}

@Injectable({
    providedIn: "root",
})
export class Auth0Service {
    readonly AUTHENTICATION_KEY = "authentication";

    constructor(
        @Inject(BASE_API_URL) private readonly baseApiUrl: string,
        private readonly http: HttpClient,
        private readonly router: Router,
        private readonly auth0: Auth0SDK
    ) { }

    /**
     * Called from /login/select-user
     * Bridges Auth0 login → backend session
     */
    getUser(): Observable<any> {
        return this.auth0.isAuthenticated$
            .pipe(
                filter(isAuth => isAuth === true),
                take(1),
                switchMap(() => this.auth0.getAccessTokenSilently()),
                switchMap(() => this.callMeApi())
            );
    }

    /**
     * Backend API call
     */
    private callMeApi() {
        const url = `${this.baseApiUrl}me`;
        return this.http.get(url).pipe(map((response: any) => response));
    }
}
